import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Accept, FileRejection, useDropzone } from 'react-dropzone'

import Icon from '../../ui/Icon'

type DropZoneInputProps = {
  children: ReactNode
  onFilesSelected: (files: File[]) => void
  onFilesRejected?: (rejections: FileRejection[]) => void
  accept?: Accept
  multiple?: boolean
  disabled?: boolean
  maxSize?: number
  className?: string
}

const DropZoneInput = ({
  children,
  onFilesSelected,
  onFilesRejected,
  accept,
  multiple = false,
  disabled = false,
  maxSize,
  className = '',
}: DropZoneInputProps) => {
  const { t } = useTranslation('inputs')
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    multiple,
    disabled,
    maxSize,
    onDrop: acceptedFiles => {
      if (acceptedFiles.length) {
        onFilesSelected(acceptedFiles)
      }
    },
    onDropRejected: onFilesRejected,
  })

  const classes =
    `dropzone-input ${className} ` +
    `${isDragActive ? 'dropzone-active' : ''} ` +
    `${disabled ? 'dropzone-disabled' : ''}`

  return (
    <div {...getRootProps()} className={classes.trim()}>
      <input {...getInputProps()} />
      {children}
      {isDragActive && (
        <div className="dropzone-overlay">
          <Icon name="upload" size={36} />
          <span>{t('drop-image-here')}</span>
        </div>
      )}
    </div>
  )
}

export default DropZoneInput
